var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopRightArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 20h17v17l-7.07-7.1L22.83 56 20 53.17l26.1-26.1L39 20z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top_right_arrow_B.ce3bbe2b.svg";
export { SvgJ1TopRightArrowB as ReactComponent };